import React, { useEffect, useState } from "react";
import "../../Css/Landing.css";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// import { FaLongArrowAltRight, FaUserCircle } from "react-icons/fa";
// import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import loaderGif from "../../assets/Grid.png";
import { basicauthblog } from "../../basicauth";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Script } from "../../Utils/Script";

function AllBlogs() {
  const navigate = useNavigate();

  const fromTag = sessionStorage.getItem("FromTag");
  const tagSlug = sessionStorage.getItem("tag");
  const [cards, setCards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const blogsPerPage = 8;
  const [searchTerm, setSearchTerm] = useState("");
  const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetAllProductBlog`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ webid: "6" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetBlogByHashtags = async (tagSlug) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetBlogByHashtags`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ hashtag: tagSlug, webid: "6" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      if (sessionStorage.getItem("FromTag") === "1") {
        const tagSlug = JSON.parse(sessionStorage.getItem("tag"));
        await GetBlogByHashtags(tagSlug);
        sessionStorage.removeItem("FromTag");
      } else {
        await Getproductblogs();
      }
    };

    fetchData();

    return () => controller.abort();
  }, []);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });

  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  useEffect(() => {
    Script();
  }, []);

  return (
    <>
      <Helmet>
        <title> Packky Blog — Delivery & Logistics Insights for Indian Businesses</title>

        <meta
          name="description"
          content=" Explore tips, guides, and insights on delivery management, last-mile logistics, and business growth from the Packky team."
        />
      </Helmet>
    <Navbar/>
   <section className="mb-5 mt-24 px-3 sm:mt-28 lg:mt-32">
  <h2 className="text-center text-[26px] text-[#212529] font-medium sm:text-[30px] lg:text-[34px]">
    All Blogs
  </h2>

  {/* SEARCH */}
  <div className="my-4 flex w-full justify-center">
    <div className="relative w-full max-w-[32rem]">
      <input
        type="text"
        className="form-control w-full text-sm sm:text-base"
        placeholder="Search by title, excerpt or author..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          paddingLeft: "1rem",
          paddingRight: "1rem",
          borderRadius: "50px",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
          height: "clamp(2.6rem, 6vw, 3rem)",
        }}
      />
    </div>
  </div>

  {/* LOADER */}
  {isLoading && (
    <div className="flex justify-center items-center">
      <img src={loaderGif} alt="Loading..." />
    </div>
  )}

  {/* CARDS */}
  <div className="m-0 mx-auto w-full max-w-7xl px-2 sm:px-4">
    <div className="flex flex-wrap p-0">
      {currentBlogs.map((item, i) => (
        <div
          className="mb-4 w-full p-2 sm:w-1/2 md:w-1/3 lg:w-1/4"
          key={i}
        >
          <div
            className="My-Landing-card"
            style={{
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              height: "100%",
              borderRadius: "1rem",
            }}
          >
            <img
              src={
                item.image_url ||
                "https://via.placeholder.com/300x200?text=No+Image"
              }
              alt={item.title}
              className="w-full object-contain rounded-t-xl"
            />

            <div className="px-3 pb-3 overflow-hidden">
              {/* AUTHOR */}
              <div className="mt-3 flex items-center">
                <img
                  src={item.author_image || ""}
                  alt={item.author_name}
                  className="h-8 w-8 rounded-full object-cover"
                />
                <p className="ml-2 text-[13px] font-semibold text-gray-500">
                  {item.author_name}
                </p>
              </div>

              {/* TITLE */}
              <h6 className="mt-2 line-clamp-1 text-[15px] text-[#3E3232]">
                {item.title}
              </h6>

              {/* DESC */}
              <p className="mt-1 line-clamp-4 text-[13px] text-[#3E3232]">
                {item.excerpt}
              </p>

              {/* CTA */}
              <div className="mt-2 flex justify-end">
                <div
                  onClick={() => {
  sessionStorage.setItem("selectedBlog", JSON.stringify(item));

  navigate(`/blog/${item.slug}`, {
    state: { blog: item },
  });
}}
                  className="cursor-pointer text-sm font-medium text-blue-600 hover:underline"
                >
                  Read More →
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* PAGINATION */}
    <div className="mt-6 flex flex-wrap items-center justify-center gap-2 text-sm">
      <button
        className="btn btn-outline-secondary"
        onClick={handlePrevPage}
        disabled={currentPage === 1}
      >
        &lt; Prev
      </button>

      <span className="font-semibold">
        Page {currentPage} of {totalPages}
      </span>

      <button
        className="btn btn-outline-secondary"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        Next &gt;
      </button>
    </div>
  </div>
</section>
    <Footer/>
    </>
  );
}

export default AllBlogs;